
import refreshCurrentUser, { isUserAuthenticated } from '../../utils/refreshCurrentUser';

export default function OnEnterLoadIdentity(store) {
  return (nextState, replace, done) => {
    isUserAuthenticated(store)
      .catch(() => refreshCurrentUser(store))
      .catch((err) => console.warn(err.body, ' User not authenticated.'))
      .then(() => done());
  };
};



// WEBPACK FOOTER //
// ./shared/react/OnEnterHooks/loadIdentity.js